import api from '@/lib/api'

const state = () => ({
  all: [],
  
  current: {
    business_name: '',
    contact_name: '',
    phone: '',
    customer_callback_phone: '',
    email: '',
    address: {
      street: '',
      city: '',
      state: '',
      zipcode: '',
    },
    notes: '',
    offered_services: [],
    referrals: [],
    referrals_enabled: true,
    partnership_status: '',
  },
})

const getters = {
  all:        state => state.all,

  currentPro: state => state.current,
}

const actions = { 
  async loadAll ({ commit }, { category, in_network, service_id } = {}) {
    let params = new URLSearchParams()
    if (category != null) params.append('category', category)
    if (in_network != null) params.append('in_network', in_network)
    if (service_id != null) params.append('service_id', service_id)

    const result = await api.get('/pros' + (params == '' ? params : '?' + params))
    if (result.ok) {
      const pros = await result.json()
      commit('SET_ALL', pros)
      return { ok: true }
    }

    if (result.status == 422) {
      commit('SET_ALL', [])
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrent ({ commit }, pro_id) {
    const result = await api.get('/pros/' + pro_id)
    if (result.ok) {
      commit('SET_CURRENT', await result.json())
      return { ok: true }
    } 

    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateCurrent ({ state, commit }, { notes, ...pro }) {
    const result = await api.put(`/pros/${state.current.pro_id}`, { partner: { notes, pro } })
    if (result.ok) {
      const newPro = await result.json()
      commit('SET_CURRENT', newPro)
    
      return { ok: true, updated: newPro }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async createPro ({ }, pro ) {
    const result = await api.post('/pros', { partner: { pro } })
    if (result.ok) {
      return { ok: true, created: await result.json() }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateCurrentOfferedServices ({ commit, state }, services) {
    let payload = { service_ids: services }
    const result = await api.put('/pros/' + state.current.pro_id + '/offered_services', payload)
    if (result.ok) {
      const pro = await result.json()
      commit('SET_CURRENT', pro)
      return { ok: true }
    } 

    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateCurrentBlacklistedServices ({ commit, state }, services) {
    let payload = { service_ids: services }
    const result = await api.put('/pros/' + state.current.pro_id + '/blacklisted_services', payload)
    if (result.ok) {
      const pro = await result.json()
      commit('SET_CURRENT', pro)
      return { ok: true }
    } 

    return { ...await result.json(), status: result.status, ok: false }
  },

  async toggleCurrentPartnershipStatus ({ commit, state }) {
    const method = `/pros/${state.current.pro_id}/toggle_partnership`
    const result = await api.put(method)
    if (result.ok) {
      const newPro = await result.json()
      commit('SET_CURRENT', newPro)
      return { ok: true, updated: newPro }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },
  
  // eslint-disable-next-line no-empty-pattern
  async exampleLead ({ }, { pro_id }) {
    const method = `/pros/${ pro_id }/example_lead`
    const result = await api.put(method)
    if (result.ok) {
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },
  
  // eslint-disable-next-line no-empty-pattern
  async reinvite ({ }, { pro_id }) {
    const method = `/pros/${ pro_id }/reinvite`
    const result = await api.put(method)
    if (result.ok) {
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async toggleCurrentPause ({ commit, state }) {
    const method = `/pros/${state.current.pro_id}/toggle_pause`
    const result = await api.put(method)
    if (result.ok) {
      const newPro = await result.json()
      commit('SET_CURRENT', newPro)
      return { ok: true, updated: newPro }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async delete ({ commit }, { pro_id }) {
    const result = await api.delete('/pros/' + pro_id)
    if (result.ok) {
      commit('DELETE', pro_id)
      dispatchEvent('loadAll')
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  }
}

const mutations = { 
  SET_ALL (state, pros) {
    state.all = pros
  },

  SET_CURRENT (state, pro) {
    state.current = pro
  },

  DELETE (state, pro_id) {
    let new_pros = state.pros.filter( p => p.pro_id != pro_id )
    state.pros = new_pros
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}